<div class="notifications flex align-items-center">
  <div class="relative notifications--popup--familia">
    <div
      class="notifications--icon"
      tabindex="-1"
      (click)="reload($event)"
      (keyup.enter)="reload($event)">
      <app-cigna-icon icon="notify"></app-cigna-icon>
      @if (unreadCount !== 0) {
        <span class="notifications--count" style="font-size: 2rem">·</span>
      }
    </div>
    <p-menu
      #menu6
      [popup]="true"
      (onShow)="openMenu('notificaciones')"
      (onHide)="closeMenu('notificaciones')"
      [model]="notifications?.content">
      <ng-template pTemplate="start">
        <div class="notifications--container--top">
          <div class="notifications--container--top--header flex w-full">
            <div class="flex">
              <span class="xl-serif-bold">{{ 'notifications.title' | translate }}</span>
            </div>
            <div class="flex">
              <div class="flex notifications--container--top--header--count">
                <div class="flex align-items-center justify-content-center w-full">
                  {{ unreadCount }}
                </div>
              </div>
            </div>
          </div>
          <div class="notifications--container--top--header--text">
            {{ 'notifications.subtitle' | translate }}
          </div>
          @if (notifications.content.length) {
            <div class="flex notifications--container--top--header--check-all w-full">
              <div class="flex">
                <app-cigna-icon
                  icon="done"
                  class="size-24 mr-1"
                  (click)="labelAllAsRead()"></app-cigna-icon>
              </div>
              <div
                class="flex align-items-center w-full"
                tabindex="0"
                (click)="labelAllAsRead()"
                (keyup.enter)="labelAllAsRead()">
                {{ 'notifications.check' | translate }}
              </div>
            </div>
          }
        </div>
      </ng-template>
      <ng-template pTemplate="item" let-item>
        <div class="notifications--container--down">
          <div
            class="flex"
            tabindex="0"
            (click)="$event.stopPropagation()"
            (keyup.enter)="$event.stopPropagation()"
            [ngClass]="{
              'notifications--element': item.read,
              'notifications--element--blue': !item.read,
            }">
            <div class="flex align-items-start justify-content-center">
              <app-cigna-icon
                [icon]="item.icon"
                class="size-24 blue notifications--container--down--icon align-items-center justify-content-center flex"></app-cigna-icon>
              @if (!item.read) {
                <span class="notifications--container--down--icon--count relative">·</span>
              }
            </div>
            <div class="flex">
              <div class="flex flex-column ml-2">
                <div
                  class="notifications--container--down--text"
                  [innerHTML]="
                    language === 'es' ? item.notification : item.notificationEnglish
                  "></div>

                <div class="notifications--container--down--text--action">
                  @if (item.actionType === 'DOWNLOAD') {
                    <span
                      [innerHTML]="language === 'es' ? item.action : item.actionEnglish"
                      tabindex="0"
                      (click)="downloadFile(item.link, item.filename, item.id)"
                      (keyup.enter)="downloadFile(item.link, item.filename, item.id)">
                    </span>
                  }
                  @if (item.actionType === 'ACCEPT') {
                    <span
                      [innerHTML]="language === 'es' ? item.action : item.actionEnglish"
                      tabindex="0"
                      (click)="openSign(item.link, 'ACCEPT', item.id)"
                      (keyup.enter)="openSign(item.link, 'ACCEPT', item.id)">
                    </span>
                  }
                  @if (item.actionType === 'SIGN') {
                    <span
                      tabindex="0"
                      [innerHTML]="language === 'es' ? item.action : item.actionEnglish"
                      (click)="openSign(item.link, 'SIGN', item.id)"
                      (keyup.enter)="openSign(item.link, 'SIGN', item.id)">
                    </span>
                  }

                  @if (item.actionType === 'REDIRECT') {
                    <span
                      [innerHTML]="language === 'es' ? item.action : item.actionEnglish"
                      tabindex="0"
                      (click)="redirect(item.id, item.link)"
                      (keyup.enter)="redirect(item.id, item.link)">
                    </span>
                  }
                </div>
              </div>
            </div>
            <div>
              <!--<div style="text-align: -webkit-right">
                <app-cigna-icon
                  icon="cross"
                  class="error size-16 mr-1"
                  (click)="deleteNotification(item.id)"></app-cigna-icon>
              </div>-->
              <div class="notifications--container--down--text--time">
                <small>{{ item.time }}</small>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="end">
        <div
          class="flex notifications--container--footer justify-content-center align-items-center w-full">
          @if (showMoreButton) {
            <div class="flex">
              <app-cigna-icon
                icon="chevron-down"
                class="size-24 mr-2"
                tabindex="0"
                (click)="viewMore()"
                (keyup.enter)="viewMore()"></app-cigna-icon>
            </div>
            <div class="flex">
              <div tabindex="0" (click)="viewMore()" (keyup.enter)="viewMore()">
                {{ 'notifications.more' | translate }}
              </div>
            </div>
          }
        </div>
      </ng-template>
    </p-menu>
  </div>
</div>
